import API from "./api";
import { Profile_API_URLS } from "./constants";
export function getMyProfileDetailsApi(id) {
  return API.get(`${Profile_API_URLS.getMyProfileDetailsUrl}/${id}`);
}
